import { render } from "./pricing.vue?vue&type=template&id=4a0761fa"
import script from "./pricing.vue?vue&type=script&lang=js"
export * from "./pricing.vue?vue&type=script&lang=js"

import "./pricing.vue?vue&type=style&index=0&id=4a0761fa&lang=css"

import exportComponent from "/root/workspace/cinema-admin_TXA8/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__